import { html } from 'lit'
import { TrivialDeliveryPolicy } from 'components/ordering/acl/internal-types.js'

export function renderDeliveryPolicyBadge(deliveryPolicyName: string | null, bordered: boolean = false, deliveryPolicyBadgeVariant: string = 'new') {
  const isConfiguredDeliveryPolicy = deliveryPolicyName !== null && deliveryPolicyName !== new TrivialDeliveryPolicy().name
  if (isConfiguredDeliveryPolicy) {
    return html`
      <cse-badge variant="${deliveryPolicyBadgeVariant}" size="small" class="basket-delivery-policy" composition="${bordered ? 'floating' : 'solid'}">
        ${deliveryPolicyName}
      </cse-badge>
    `
  }
  return null
}
